import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

/**
 * Smoothly scrolls to a target element or element ID with a cinematic ease curve.
 * Works reliably on mobile/touch screens and desktop without premature auto-kill.
 * @param {string|HTMLElement} targetOrId - Element ID or DOM element to scroll to
 * @param {number} duration - Scroll duration in seconds (default: 1.0s)
 */
export const smoothScrollTo = (targetOrId, duration = 1.0) => {
  const target = typeof targetOrId === 'string'
    ? document.getElementById(targetOrId)
    : targetOrId;

  if (!target) return;

  // Cancel any active window scrolls to avoid conflicting tweens
  gsap.killTweensOf(window);

  // Compute exact target position on page
  const targetY = target.getBoundingClientRect().top + window.pageYOffset;

  gsap.to(window, {
    duration,
    scrollTo: {
      y: targetY,
      autoKill: false, // Critical: prevent mobile touch/tap inertia from abruptly stopping the scroll
    },
    ease: 'power3.inOut',
  });
};
